var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"internet"},[(!_vm._isMobile)?_c('internetPc'):_c('internetMobile'),_vm._v(" "),(!_vm._isMobile)?_c('customizedService',{attrs:{"text":"多家知名互联网企业的","colorText":"依赖伙伴"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7059baef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/internet.vue
// module id = null
// module chunks = 